import Swiper from 'swiper';
import {Navigation, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import InitTabs from '@utils/initTabs';

document.addEventListener('DOMContentLoaded', function ()
{
    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: {
                left: ["infobar"],
                right: ["close"],
            },
        },
    });

    const swiperElementModels = document.querySelector('.swiper-models');
    if (swiperElementModels) {
        const swiperModels = new Swiper(swiperElementModels, {
            loop: true,
            modules: [Navigation],
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-next-models",
                prevEl: ".swiper-prev-models",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                }
            }
        });
    }

    const swiperElementWelcome = document.querySelector('.swiper-welcome');
    if (swiperElementWelcome) {
        const swiperWelcome = new Swiper(swiperElementWelcome, {
            loop: true,
            modules: [Navigation, Autoplay],
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-next-welcome",
                prevEl: ".swiper-prev-welcome",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                }
            }
        });
    }

    const swiperElementInterior = document.querySelector('.swiper-interior');
    if (swiperElementInterior) {
        const swiperGalleryInterior = new Swiper('.swiper-interior', {
            loop: true,
            modules: [Navigation, Autoplay],
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-next-interior",
                prevEl: ".swiper-prev-interior",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 15
                }
            }
        });
    }

    const swiperElementExterior = document.querySelector('.swiper-exterior');
    if (swiperElementExterior) {
        const swiperGalleryExterior = new Swiper('.swiper-exterior', {
            loop: true,
            modules: [Navigation, Autoplay],
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-next-exterior",
                prevEl: ".swiper-prev-exterior",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 15
                }
            }
        });
    }

    const promo = document.querySelector('#promotion-quotes');

    if (promo) {
        const inner = promo.querySelector('.promotion');
        const btnClose = promo.querySelector('.btn-close');

        let cycleInterval;
        let hideTimeout;

        // Función para mostrar con fadeIn
        function fadeIn(element) {
            promo.style.display = 'block';
            // Pequeño delay para que la transición funcione
            setTimeout(() => {
                element.classList.remove('fade-out');
                element.classList.add('fade-in');
            }, 10);
        }

        function fadeOut(element) {
            element.classList.remove('fade-in');
            element.classList.add('fade-out');

            element.addEventListener('transitionend', function handler() {
                promo.style.display = 'none';
                element.removeEventListener('transitionend', handler);
            }, {once: true});
        }

        function startCycle() {
            fadeIn(inner);

            hideTimeout = setTimeout(() => {
                fadeOut(inner);
            }, 10000);
        }

        startCycle();

        // Repetir cada 30 segundos (10s visible + 20s oculto)
        cycleInterval = setInterval(startCycle, 30000);

        if (btnClose) {
            btnClose.addEventListener('click', () => {
                clearTimeout(hideTimeout);
                clearInterval(cycleInterval);
                fadeOut(inner);
            });
        }
    }

    const header = document.getElementById('main-header');
    const projectNavbar = document.getElementById('project-navbar');
    const navLinks = document.querySelectorAll('.nav-item');

    if (!header || !projectNavbar) {
        console.warn('Elementos no encontrados:', {
            header: !!header,
            projectNavbar: !!projectNavbar
        });
        return;
    }

    const SCROLL_THRESHOLD = 150;

    function handleScroll() {
        const scrollY = window.scrollY;

        if (scrollY >= SCROLL_THRESHOLD) {
            header.style.display = 'none';

            projectNavbar.classList.add('fixed', 'top-0', 'left-0', 'right-0', 'z-40');
            projectNavbar.style.top = '0';
            projectNavbar.style.transition = 'all 0.3s ease';
        } else {
            header.style.display = '';

            projectNavbar.classList.remove('fixed', 'top-0', 'left-0', 'right-0', 'z-40');
            projectNavbar.style.top = '';
        }

        navLinks.forEach(link => {
            link.classList.remove('nav-active');
            const href = link.getAttribute('href');

            if (href && href.startsWith('#')) {
                const section = document.querySelector(href);
                if (section) {
                    const rect = section.getBoundingClientRect();
                    if (rect.top <= 150 && rect.bottom >= 150) {
                        link.classList.add('nav-active');
                    }
                }
            }
        });
    }

    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');

            if (href && href.startsWith('#')) {
                e.preventDefault();
                const target = document.querySelector(href);

                if (target) {
                    navLinks.forEach(l => l.classList.remove('nav-active'));
                    this.classList.add('nav-active');

                    const offset = header.offsetHeight + 20;

                    window.scrollTo({
                        top: target.offsetTop - offset,
                        behavior: 'smooth'
                    });
                }
            }
        });
    });

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    handleScroll();
});
